export default class DriverService {
    constructor(){

    }

    isValidDob(dob: Date){
        // Check if the date is valid
        var date = new Date(dob);
        if (!date || isNaN(date.getTime())) {
          return false;
        }
      
        // Check if the date is in the past
        var today = new Date();
        if (date > today) {
          return false;
        }
      
        var yearsDiff = today.getFullYear() - date.getFullYear();

        if(yearsDiff > 100){
            return false;
        }
     
        return true;
    }
}